<script setup lang="ts">
defineProps<{ id: string; message?: string | undefined }>()
</script>

<template>
  <p v-if="message" :id="id" class="field-error"><span aria-hidden="true">⚠</span> {{ message }}</p>
</template>
